export enum TPSActionTypes {
  EFTManualPay = 'EFTManualPay',
  EFTSwipePay = 'EFTSwipePay',
  EFTRefund = 'EFTRefund',
  OnlineItem = 'OnlineItem',
  Refund = 'Refund',
  EFTPreAuthorization = 'EFTPreAuthorization',
  EFTPostVoid = 'EFTPostVoid',
  EFTPreAuthorizationForPrePaid = 'EFTPreAuthorizationForPrePaid',
}
